// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'battery-charge';

export const Component = () => (
  <path d='M23.038 8.927h-.48V6.485a1.41 1.41 0 0 0-.43-1.054A1.408 1.408 0 0 0 21.072 5H1.485c-.431 0-.766.144-1.054.431A1.408 1.408 0 0 0 0 6.485v10.776c0 .431.144.766.431 1.054.288.287.623.431 1.054.431h19.588c.432 0 .767-.144 1.054-.431.288-.288.432-.623.432-1.054v-2.442h.479c.43 0 .766-.144 1.053-.432.288-.287.432-.622.432-1.053v-2.97c0-.383-.144-.719-.432-1.005a1.411 1.411 0 0 0-1.053-.432Zm.526 1.437v2.97c0 .335-.191.479-.526.479H21.6v3.448c0 .335-.192.479-.527.479H1.486c-.335 0-.527-.144-.527-.48V6.486c0-.335.192-.526.527-.526h19.588c.335 0 .527.191.527.526v3.4h1.437c.335 0 .526.144.526.48Zm-10.823-3.4-.958 3.927 1.963.958-3.975 4.933 1.006-3.927-1.964-1.006 3.928-4.885Z' />
);

export const viewBox = '0 0 25 25';
